module.exports = __webpack_public_path__ + "img/loginImg.cca92204.png";